#import '../../fragments/userNotification.fragment.graphql'

mutation markAllAsRead {
  markAllAsRead(input: {}) {
    notifications {
      ...UserNotificationFragment
    }
  }
}
